import { render, staticRenderFns } from "./submitWork.vue?vue&type=template&id=cda069bc&scoped=true"
import script from "./submitWork.vue?vue&type=script&lang=js"
export * from "./submitWork.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cda069bc",
  null
  
)

export default component.exports